export default {
  fromValue (val) {
    switch (val) {
      case 'money':
        return 'Dinheiro'
      case 'pix':
        return 'PIX'
      case 'debit':
        return 'Débito'
      case 'credit':
        return 'Crédito'
      case 'pinpag':
        return 'PinPag'
      default:
        return val
    }
  }
}
